// extracted by mini-css-extract-plugin
module.exports = {"horizontalRule":"HorizontalRule_horizontalRule__3p7mH","large":"HorizontalRule_large__1utDP","small":"HorizontalRule_small__3UAHV"};